"use strict";
// import React, { useEffect, useState } from "react";
// import { Gallery } from "../../../../components/gallery";
// import { get_lot } from "../../../../api/calls/lot/get_lot";
// import { useDispatch, useSelector } from "react-redux";
// import { setMessageModal } from "../../../../reducers/slices/main";
// import { LoaderContent } from "../../../../components/loader_content";
// import { LabelControl, PillsControl } from "doshx_controls_web";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFilePdf } from "@fortawesome/pro-duotone-svg-icons";
// import { LotStatusTag } from "../../../../components/tags/lot_status_tag";
// import { IAuctionSliceState } from "../../../../reducers/slices/auction";
// import { faCircleLocationArrow, faEnvelope, faPhone } from "@fortawesome/pro-solid-svg-icons";
// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
// import { callingIcon, crossIcon, mailIcon, mapIcon, msgIcon, pdficon, whatsappIcon } from "../../../../../../assets/icons";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotDetailsModal = void 0;
// interface IProps {
//   lot_id: string;
// }
// export const LotDetailsModal = (props: IProps) => {
//   const { lot_id } = props;
//   const dispatch = useDispatch();
//   const { liveAuction, auction } = useSelector<any, IAuctionSliceState>((state) => state.auctionState);
//   const [isLoading, setIsLoading] = React.useState<boolean>(true);
//   const [lot, setLot] = React.useState<any>(null);
//   const [extraData, setExtraData] = React.useState<any>([]);
//   const [modalIcon , setIconModal] = useState(false);
//   useEffect(() => {
//     setIsLoading(true);
//     get_lot({
//       entity_id: lot_id,
//     }).then((response) => {
//       setIsLoading(false);
//       if (response.success) {
//         setLot(response.content);
//       } else {
//         dispatch(
//           setMessageModal({
//             title: "Oops!",
//             messages: [
//               "Something went wrong while getting the lot details.", //
//               response.message,
//             ],
//           }),
//         );
//       }
//     });
//   }, []);
//   const handleWhatsAppEnquiry =() => {
//     window.open(`https://wa.me/${liveAuction?.contact_details?.whatsapp?.number}?text=Hello`);
//    }
//    const handleCallEnquiry = () => {
//     window.open(`tel:${liveAuction?.contact_details?.phone?.number}`);
//    }
//    const handleMailEnquiry = () => {
//     window.open(`mailto:${liveAuction?.contact_details?.email}`);
//    }
//    const handleMsgEnquiry = () => {
//     window.open(`sms:?body=${liveAuction?.contact_details?.phone?.number}`);
//    }
//    const handleMapEnquiry = () => {
//     window.open(`https://maps.google.com?q=${lot.location.latitude},${lot?.location.longitude}`, "_blank");   }
//   useEffect(() => {
//     if (lot != null) {
//       let arr: any = [];
//       if (lot.extra_data) {
//         for (const e of lot.extra_data) {
//           arr.push({
//             label: `${e.key}: ${e.value}`,
//             // icon: faWhatsapp,
//             colors: {
//               iconColor: "text-green-500",
//             },
//           });
//         }
//       }
//       setExtraData(arr);
//     }
//   }, [lot]);
//   return (
//     <LoaderContent loading={isLoading} className="max-w-[600px] flex flex-col items-center">
//       <div className="p-2 flex flex-col gap-4">
//         <div className="flex flex-row">
//           <div className="flex flex-col flex-1">
//             <div className="flex items-center">
//               <div className="flex-1 text-lg font-bold flex gap-1">
//                 <div className=""># {lot?.lot_number}</div>
//                 <div className="">-</div>
//                 <div className="">{lot?.title}</div>
//               </div>
//             </div>
//           </div>
//           <div className="flex items-center">
//             <LotStatusTag auctionStatus={liveAuction?.status} lotStatus={lot?.status} size="small" />
//           </div>
//         </div>
//         <div className="flex justify-center pt-4">
//           <Gallery
//             images={lot?.images?.map((image: any, index: number) => {
//               return {
//                 src: image?.uploaded_file_url,
//                 alt: image?.title,
//               };
//             })}
//           />
//         </div>
//         {/* <div className="flex"> */}
//         <div className="text-lg font-bold text-center">Broker Image</div>
//         <div className="flex justify-center pt-4">
//           <Gallery
//             images={lot?.broker_images?.map((image: any, index: number) => {
//               return {
//                 src: image?.uploaded_file_url,
//                 alt: image?.title,
//               };
//             })}
//           />
//         </div>
//         {(liveAuction?.contact_details?.whatsapp?.number || liveAuction?.contact_details?.phone?.number || liveAuction?.contact_details?.email) && (
//           // <div className="text-lg font-bold">Auction Contact Details</div>
//          <>
//          <div className="text-lg font-bold text-center">{lot?.broker_name}</div>
//           <div className="text-lg font-bold text-center">Broker Contact Details</div>
//          </>
//         )}
//         <PillsControl
//           size="medium"
//           pillSpacing="justify-center"
//           pills={[
//             {
//               visible: !!liveAuction?.contact_details?.whatsapp?.number,
//               label: `${liveAuction?.contact_details?.whatsapp?.number}`,
//               icon: faWhatsapp,
//               colors: {
//                 iconColor: "text-green-500",
//               },
//             },
//             {
//               visible: !!liveAuction?.contact_details?.phone?.number,
//               label: `${liveAuction?.contact_details?.phone?.number}`,
//               icon: faPhone,
//               colors: {
//                 iconColor: "text-blue-500",
//               },
//             },
//             {
//               visible: !!liveAuction?.contact_details?.email,
//               label: `${liveAuction?.contact_details?.email}`,
//               icon: faEnvelope,
//               colors: {
//                 iconColor: "text-green-500",
//               },
//             },
//           ]}
//           colors={{
//             pills: {
//               shadowColor: "shadow-gray-200",
//               backgroundColor: "bg-gray-100",
//             },
//           }}
//         />
//         {/* </div> */}
//         {(lot?.contacts?.whatsapp?.number || lot?.contacts?.phone?.number || lot?.contacts?.email) && (
//           <div className="text-lg font-bold">Lot Contact Details</div>
//         )}
//         <PillsControl
//           size="medium"
//           pillSpacing="justify-center"
//           pills={[
//             {
//               visible: !!lot?.contacts?.whatsapp?.number,
//               label: `${lot?.contacts?.whatsapp?.number}`,
//               icon: faWhatsapp,
//               colors: {
//                 iconColor: "text-green-500",
//               },
//             },
//             {
//               visible: !!lot?.contacts?.phone?.number,
//               label: `${lot?.contacts?.phone?.number}`,
//               icon: faPhone,
//               colors: {
//                 iconColor: "text-blue-500",
//               },
//             },
//             {
//               visible: !!lot?.contacts?.email,
//               label: `${lot?.contacts?.email}`,
//               icon: faEnvelope,
//               colors: {
//                 iconColor: "text-green-500",
//               },
//             },
//           ]}
//           colors={{
//             pills: {
//               shadowColor: "shadow-gray-200",
//               backgroundColor: "bg-gray-100",
//             },
//           }}
//         />
//         {lot?.location && (
//           <div className="flex gap-2 justify-end items-center">
//             <span className="text-lg text-black">
//               <FontAwesomeIcon icon={faCircleLocationArrow} />
//             </span>
//             <div
//               className="cursor-pointer"
//               onClick={() => {
//                 window.open(`https://maps.google.com?q=${lot.location.latitude},${lot.location.longitude}`, "_blank");
//               }}
//             >
//               <LabelControl size="medium" label={lot?.location.full_address} textColor="text-black" />
//             </div>
//           </div>
//         )}
//         <div className="text-sm">{lot?.description}</div>
//         <div className="flex justify-center pt-4">
//           <div className="pt-4 max-w-96">
//             {extraData && (
//               <PillsControl
//                 size="small"
//                 pillSpacing="justify-center"
//                 pills={extraData}
//                 colors={{
//                   pills: {
//                     shadowColor: "shadow-gray-200",
//                     backgroundColor: "bg-cyan-600",
//                     textColor: "text-white",
//                   },
//                 }}
//               />
//             )}
//           </div>
//         </div>
//         <div className="pt-4">
//           <div className="text-md font-bold">Documents</div>
//           <div className="flex flex-wrap gap-4">
//             {lot?.documents?.length > 0 ? (
//               lot.documents.map((document: any, index: any) => {
//                 return (
//                   <div key={index}>
//                     <a href={document.uploaded_file_url} target="_blank" rel="">
//                       <div className="flex gap-2 items-center py-2 px-4 bg-[#EF4444] text-white w-fit rounded-lg hover:underline">
//                         {/* <FontAwesomeIcon icon={faFilePdf} size="lg" /> */}
//                         {pdficon}
//                         {document.uploaded_file_url.split("/").pop()}
//                       </div>
//                     </a>
//                   </div>
//                 );
//               })
//             ) : (
//               <div className="">
//                 <>No documents for this lot.</>
//               </div>
//             )}
//           </div>
//           <div className="flex items-center justify-center mt-2">
//           <div className=" w-full max-w-[358px] px-6 py-3 bg-[#16A34A] rounded-[10px] text-white mt-2 cursor-pointer flex justify-center items-center" onClick={() =>{setIconModal(true)}}>Enquire now</div></div>
//         </div>
//       </div>
//       {modalIcon && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
//           <div className="bg-white rounded-xl p-4 w-[90%] max-w-sm shadow-lg relative">
//             {/* Header */}
//             <div className="flex justify-between items-center mb-2">
//               <h3 className="text-lg font-semibold">Contact Details</h3>
//               <button className="border border-black rounded-md px-2.5 py-2.5" onClick={() => setIconModal(false)}>
//              {crossIcon}
//               </button>
//             </div>
//             <hr />
//             {/* Icons Row */}
//             <div className="flex gap-3 mt-4">
//               <span className="cursor-pointer" onClick={handleWhatsAppEnquiry}>
//                 {whatsappIcon}
//               </span>
//               <span className="cursor-pointer" onClick={handleMailEnquiry}>
//                 {mailIcon}
//               </span>
//               <span className="cursor-pointer" onClick={handleMsgEnquiry} >
//                   {msgIcon}
//                 </span>
//               <span className="cursor-pointer" onClick={handleMapEnquiry} >
//                 {mapIcon}
//               </span>
//               <span className="cursor-pointer" onClick={handleCallEnquiry}>
//                   {callingIcon}
//                 </span>
//             </div>
//           </div>
//         </div>
//       )}
//     </LoaderContent>
//   );
// };
var react_1 = __importStar(require("react"));
var gallery_1 = require("../../../../components/gallery");
var get_lot_1 = require("../../../../api/calls/lot/get_lot");
var react_redux_1 = require("react-redux");
var main_1 = require("../../../../reducers/slices/main");
var loader_content_1 = require("../../../../components/loader_content");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var lot_status_tag_1 = require("../../../../components/tags/lot_status_tag");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
var icons_1 = require("../../../../../../assets/icons");
var LotDetailsModal = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    var lot_id = props.lot_id;
    var dispatch = (0, react_redux_1.useDispatch)();
    var liveAuction = (0, react_redux_1.useSelector)(function (state) { return state.auctionState; }).liveAuction;
    var _8 = react_1.default.useState(true), isLoading = _8[0], setIsLoading = _8[1];
    var _9 = react_1.default.useState(null), lot = _9[0], setLot = _9[1];
    var _10 = react_1.default.useState([]), extraData = _10[0], setExtraData = _10[1];
    var _11 = (0, react_1.useState)(false), modalIcon = _11[0], setIconModal = _11[1];
    (0, react_1.useEffect)(function () {
        setIsLoading(true);
        (0, get_lot_1.get_lot)({
            entity_id: lot_id,
        }).then(function (response) {
            setIsLoading(false);
            if (response.success) {
                setLot(response.content);
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Oops!",
                    messages: [
                        "Something went wrong while getting the lot details.",
                        response.message,
                    ],
                }));
            }
        });
    }, []);
    var handleWhatsAppEnquiry = function () {
        var _a, _b;
        window.open("https://wa.me/".concat((_b = (_a = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _a === void 0 ? void 0 : _a.whatsapp) === null || _b === void 0 ? void 0 : _b.number, "?text=Hello"));
    };
    var handleCallEnquiry = function () {
        var _a, _b;
        window.open("tel:".concat((_b = (_a = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.number));
    };
    var handleMailEnquiry = function () {
        var _a;
        window.open("mailto:".concat((_a = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _a === void 0 ? void 0 : _a.email));
    };
    var handleMsgEnquiry = function () {
        var _a, _b;
        window.open("sms:?body=".concat((_b = (_a = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.number));
    };
    var handleMapEnquiry = function () {
        window.open("https://maps.google.com?q=".concat(lot.location.latitude, ",").concat(lot === null || lot === void 0 ? void 0 : lot.location.longitude), "_blank");
    };
    (0, react_1.useEffect)(function () {
        if (lot != null) {
            var arr = [];
            if (lot.extra_data) {
                for (var _i = 0, _a = lot.extra_data; _i < _a.length; _i++) {
                    var e = _a[_i];
                    arr.push({
                        label: "".concat(e.key, ": ").concat(e.value),
                        // icon: faWhatsapp,
                        colors: {
                            iconColor: "text-green-500",
                        },
                    });
                }
            }
            setExtraData(arr);
        }
    }, [lot]);
    return (react_1.default.createElement(loader_content_1.LoaderContent, { loading: isLoading, className: "max-w-[600px] flex flex-col items-center" },
        react_1.default.createElement("div", { className: "p-2 flex flex-col gap-4" },
            react_1.default.createElement("div", { className: "flex flex-row" },
                react_1.default.createElement("div", { className: "flex flex-col flex-1" },
                    react_1.default.createElement("div", { className: "flex items-center" },
                        react_1.default.createElement("div", { className: "flex-1 text-lg font-bold flex gap-1" },
                            react_1.default.createElement("div", { className: "" },
                                "# ", lot === null || lot === void 0 ? void 0 :
                                lot.lot_number),
                            react_1.default.createElement("div", { className: "" }, "-"),
                            react_1.default.createElement("div", { className: "" }, lot === null || lot === void 0 ? void 0 : lot.title)))),
                react_1.default.createElement("div", { className: "flex items-center" },
                    react_1.default.createElement(lot_status_tag_1.LotStatusTag, { auctionStatus: liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.status, lotStatus: lot === null || lot === void 0 ? void 0 : lot.status, size: "small" }))),
            react_1.default.createElement("div", { className: "flex justify-center pt-4" },
                react_1.default.createElement(gallery_1.Gallery, { images: (_a = lot === null || lot === void 0 ? void 0 : lot.images) === null || _a === void 0 ? void 0 : _a.map(function (image, index) {
                        return {
                            src: image === null || image === void 0 ? void 0 : image.uploaded_file_url,
                            alt: image === null || image === void 0 ? void 0 : image.title,
                        };
                    }) })),
            (((_c = (_b = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _b === void 0 ? void 0 : _b.whatsapp) === null || _c === void 0 ? void 0 : _c.number) || ((_e = (_d = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _d === void 0 ? void 0 : _d.phone) === null || _e === void 0 ? void 0 : _e.number) || ((_f = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _f === void 0 ? void 0 : _f.email)) && (react_1.default.createElement("div", { className: "text-lg font-bold" }, "Auction Contact Details")),
            react_1.default.createElement("div", { className: "flex gap-2" },
                react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "medium", pillSpacing: "justify-center", pills: [
                        {
                            visible: !!((_h = (_g = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _g === void 0 ? void 0 : _g.whatsapp) === null || _h === void 0 ? void 0 : _h.number),
                            label: "".concat((_k = (_j = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _j === void 0 ? void 0 : _j.whatsapp) === null || _k === void 0 ? void 0 : _k.number),
                            icon: free_brands_svg_icons_1.faWhatsapp,
                            colors: {
                                iconColor: "text-white",
                            },
                        },
                    ], colors: {
                        pills: {
                            shadowColor: "shadow-gray-200",
                            backgroundColor: "bg-[#4CAF50]",
                            textColor: "text-white",
                        },
                    } }),
                react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "medium", pillSpacing: "justify-center", pills: [
                        {
                            visible: !!((_m = (_l = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _l === void 0 ? void 0 : _l.phone) === null || _m === void 0 ? void 0 : _m.number),
                            label: "".concat((_p = (_o = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _o === void 0 ? void 0 : _o.phone) === null || _p === void 0 ? void 0 : _p.number),
                            icon: pro_solid_svg_icons_1.faPhone,
                            colors: {
                                iconColor: "text-white",
                            },
                        },
                        {
                            visible: !!((_q = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _q === void 0 ? void 0 : _q.email),
                            label: "".concat((_r = liveAuction === null || liveAuction === void 0 ? void 0 : liveAuction.contact_details) === null || _r === void 0 ? void 0 : _r.email),
                            icon: pro_solid_svg_icons_1.faEnvelope,
                            colors: {
                                iconColor: "text-white",
                            },
                        },
                    ], colors: {
                        pills: {
                            shadowColor: "shadow-gray-200",
                            backgroundColor: "bg-[#446FCE]",
                            textColor: "text-white",
                        },
                    } })),
            (((_t = (_s = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _s === void 0 ? void 0 : _s.whatsapp) === null || _t === void 0 ? void 0 : _t.number) || ((_v = (_u = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _u === void 0 ? void 0 : _u.phone) === null || _v === void 0 ? void 0 : _v.number) || ((_w = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _w === void 0 ? void 0 : _w.email)) && (react_1.default.createElement("div", { className: "text-lg font-bold" }, "Lot Contact Details")),
            react_1.default.createElement("div", { className: "flex gap-2" },
                react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "medium", pillSpacing: "justify-center", pills: [
                        {
                            visible: !!((_y = (_x = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _x === void 0 ? void 0 : _x.whatsapp) === null || _y === void 0 ? void 0 : _y.number),
                            label: "".concat((_0 = (_z = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _z === void 0 ? void 0 : _z.whatsapp) === null || _0 === void 0 ? void 0 : _0.number),
                            icon: free_brands_svg_icons_1.faWhatsapp,
                            colors: {
                                iconColor: "text-white",
                            },
                        },
                    ], colors: {
                        pills: {
                            shadowColor: "shadow-gray-200",
                            backgroundColor: "bg-[#4CAF50]",
                            textColor: "text-white",
                        },
                    } }),
                react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "medium", pillSpacing: "justify-center", pills: [
                        {
                            visible: !!((_2 = (_1 = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _1 === void 0 ? void 0 : _1.phone) === null || _2 === void 0 ? void 0 : _2.number),
                            label: "".concat((_4 = (_3 = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _3 === void 0 ? void 0 : _3.phone) === null || _4 === void 0 ? void 0 : _4.number),
                            icon: pro_solid_svg_icons_1.faPhone,
                            colors: {
                                iconColor: "text-white",
                            },
                        },
                        {
                            visible: !!((_5 = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _5 === void 0 ? void 0 : _5.email),
                            label: "".concat((_6 = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _6 === void 0 ? void 0 : _6.email),
                            icon: pro_solid_svg_icons_1.faEnvelope,
                            colors: {
                                iconColor: "text-white",
                            },
                        },
                    ], colors: {
                        pills: {
                            shadowColor: "shadow-gray-200",
                            backgroundColor: "bg-[#446FCE]",
                            textColor: "text-white",
                        },
                    } })),
            (lot === null || lot === void 0 ? void 0 : lot.location) && (react_1.default.createElement("div", { className: "flex gap-2 justify-start items-center" },
                react_1.default.createElement("span", { className: "text-lg text-black" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCircleLocationArrow })),
                react_1.default.createElement("div", { className: "cursor-pointer", onClick: function () {
                        window.open("https://maps.google.com?q=".concat(lot.location.latitude, ",").concat(lot.location.longitude), "_blank");
                    } },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", label: lot === null || lot === void 0 ? void 0 : lot.location.full_address, textColor: "text-black" })))),
            react_1.default.createElement("div", { className: "text-sm" }, lot === null || lot === void 0 ? void 0 : lot.description),
            react_1.default.createElement("div", { className: "flex justify-center pt-4" },
                react_1.default.createElement("div", { className: "pt-4 max-w-96" }, extraData && (react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "small", pillSpacing: "justify-center", pills: extraData, colors: {
                        pills: {
                            shadowColor: "shadow-gray-200",
                            backgroundColor: "bg-[#446FCE]",
                            textColor: "text-white",
                        },
                    } })))),
            react_1.default.createElement("div", { className: "pt-4" },
                react_1.default.createElement("div", { className: "text-md font-bold" }, "Documents"),
                react_1.default.createElement("div", { className: "flex flex-wrap gap-4" }, ((_7 = lot === null || lot === void 0 ? void 0 : lot.documents) === null || _7 === void 0 ? void 0 : _7.length) > 0 ? (lot.documents.map(function (document, index) {
                    return (react_1.default.createElement("div", { key: index },
                        react_1.default.createElement("a", { href: document.uploaded_file_url, target: "_blank", rel: "" },
                            react_1.default.createElement("div", { className: "flex gap-4 items-center py-2 hover:underline" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faFilePdf, size: "lg" }),
                                document.uploaded_file_url.split("/").pop()))));
                })) : (react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(react_1.default.Fragment, null, "No documents for this lot.")))),
                react_1.default.createElement("div", { className: "flex items-center justify-center mt-2" },
                    react_1.default.createElement("div", { className: " w-full max-w-[358px] px-6 py-3 bg-[#16A34A] rounded-[10px] text-white mt-2 cursor-pointer flex justify-center items-center", onClick: function () {
                            setIconModal(true);
                        } }, "Enquire now")))),
        modalIcon && (react_1.default.createElement("div", { className: "fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50" },
            react_1.default.createElement("div", { className: "bg-white rounded-xl p-4 w-[90%] max-w-sm shadow-lg relative" },
                react_1.default.createElement("div", { className: "flex justify-between items-center mb-2" },
                    react_1.default.createElement("h3", { className: "text-lg font-semibold" }, "Contact Details"),
                    react_1.default.createElement("button", { className: "border border-black rounded-md px-2.5 py-2.5", onClick: function () { return setIconModal(false); } }, icons_1.crossIcon)),
                react_1.default.createElement("hr", null),
                react_1.default.createElement("div", { className: "flex gap-3 mt-4" },
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleWhatsAppEnquiry }, icons_1.whatsappIcon),
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleMailEnquiry }, icons_1.mailIcon),
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleMsgEnquiry }, icons_1.msgIcon),
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleMapEnquiry }, icons_1.mapIcon),
                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleCallEnquiry }, icons_1.callingIcon)))))));
};
exports.LotDetailsModal = LotDetailsModal;
